import { featureFlag, useFeatureFlag } from '@routable/feature-configs';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as ROUTES from 'constants/routes';
import { asPath } from 'helpers/routeHelpers';
export const useFrameSecurity = () => {
    const currentLocation = useLocation();
    const history = useHistory();
    const [isEmbedded, setIsEmbedded] = useState(false);
    const isFrameEnabled = useFeatureFlag(featureFlag.Enum.marketing_site_embedded_login);
    const isInIframe = window.self !== window.top;
    useEffect(() => {
        if (!isFrameEnabled || !isInIframe) {
            return;
        }
        if (isInIframe && currentLocation?.pathname?.indexOf('/frame') === -1) {
            if (window.top !== window.self) {
                window.top.location.href = window.location.href;
            }
        }
        if (isFrameEnabled) {
            localStorage.clear();
            sessionStorage.clear();
            document.cookie.split(';').forEach((cookie) => {
                const [name] = cookie.split('=');
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            });
            const parentHost = window.top?.location?.host ?? '';
            const token = currentLocation?.pathname?.replaceAll('/frame/', '');
            RoutableFrameSecurity?.validate(parentHost, token)
                .then(({ valid, redirect }) => {
                if (valid && redirect?.trim() !== '') {
                    sessionStorage.setItem('routable_everywhere', '1');
                    window.location.href = redirect;
                }
                else {
                    sessionStorage.setItem('routable_everywhere', valid ? '1' : '0');
                    setIsEmbedded(valid);
                    history.push(asPath(ROUTES.LOGIN));
                }
            })
                .catch(() => {
                if (isInIframe) {
                    sessionStorage.setItem('routable_everywhere', '0');
                    if (currentLocation?.pathname?.indexOf('/frame') > -1) {
                        window.top.location.href = window.location.href;
                    }
                }
            });
        }
    }, [window.top.location]);
    return { isEmbedded, isInIframe };
};
